export default __webpack_public_path__ + "static/media/medal.dbf838e0.svg";